import React from 'react';
import { Reveal } from './Reveal';
import { ArrowRight } from 'lucide-react';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'src', 'sck'];
function buildCheckoutUrl(baseUrl: string): string {
  if (typeof window === 'undefined') return baseUrl;
  try {
    const incoming = new URLSearchParams(window.location.search);
    const url = new URL(baseUrl);
    UTM_KEYS.forEach(key => {
      const value = incoming.get(key);
      if (value && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });
    return url.toString();
  } catch {
    return baseUrl;
  }
}
export function OfferSection() {
  const checkoutBase = 'https://pay.hotmart.com/T105668310M?off=bepc27hp&checkoutMode=10';
  const checkoutHref = buildCheckoutUrl(checkoutBase);
  const features = ['Cadastro ilimitado de materiais', 'Cálculo de preço em tempo real, com a sua margem', 'Recálculo automático quando um insumo muda de preço', 'Gestão de pedidos com alerta de prazo de entrega', 'Histórico de preços de cada produto', 'Resumo do mês: faturamento, lucro e margem', 'Funciona 100% no celular, sem Excel'];
  return <section id="preco" className="py-12 md:py-20 px-[5vw] bg-white relative overflow-hidden" data-id="element-440">
      {/* Decorative Blob */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-rose-soft/50 rounded-[40%_60%_70%_30%/40%_50%_60%_50%] blur-3xl pointer-events-none z-0" data-id="element-441"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-442">
        <Reveal data-id="element-443">
          {/* Title — outside the card */}
          <h2 className="font-serif font-extrabold text-[clamp(30px,5vw,48px)] text-rose tracking-[-0.02em] leading-tight mb-6 text-center" data-id="element-444">
            Condição de fundadora
          </h2>

          {/* Main Offer Card — white background, gold border, reduced rounding */}
          <div className="bg-white border border-gold rounded-2xl shadow-card relative overflow-hidden flex flex-col" data-id="element-445">
            {/* Decorative blobs */}
            <div aria-hidden="true" className="absolute -top-16 -right-12 w-48 h-48 rounded-full bg-rose-soft/50 blur-3xl pointer-events-none" data-id="element-446" />
            <div aria-hidden="true" className="absolute -bottom-20 -left-12 w-52 h-52 rounded-full bg-gold-soft/50 blur-3xl pointer-events-none" data-id="element-447" />

            {/* Header band — rose highlight with price */}
            <div className="relative z-10 w-full bg-rose px-5 md:px-8 py-6 md:py-8 flex flex-col items-center text-center" data-id="element-448">
              {/* Pre-value label */}
              <span className="inline-block bg-white/20 text-white text-[11px] md:text-xs font-bold tracking-[0.2em] uppercase px-3 py-1.5 rounded-full mb-3 border border-white/30" data-id="element-449">
                Oferta limitada
              </span>
              <div className="flex items-start justify-center gap-1" data-id="element-450">
                <span className="font-sans font-bold text-xl md:text-2xl text-white mt-1.5 md:mt-2" data-id="element-451">
                  9 x R$
                </span>
                <span className="font-sans font-extrabold text-[52px] md:text-[68px] leading-none text-white tracking-tight" data-id="element-452">
                  8,80
                </span>
              </div>
              <p className="text-gold-soft font-bold text-[15px] md:text-base mt-2" data-id="element-453">
                ou apenas R$ 67 à vista
              </p>
            </div>

            <div className="relative z-10 p-5 md:p-8 flex flex-col items-center text-center" data-id="element-454">
              {/* Features List */}
              <div className="w-full text-left mb-8" data-id="element-455">
                <p className="font-serif font-bold text-lg text-ink mb-2 text-center" data-id="element-456">
                  Você leva tudo isso:
                </p>
                <div className="w-full" data-id="element-457">
                  {features.map((item, i) => <div key={i} className={`flex items-center gap-2.5 py-2 ${i !== features.length - 1 ? 'border-b border-ink/10' : ''}`} data-id="element-458">
                      <span className="text-base flex-shrink-0 leading-none" data-id="element-459">
                        ✅
                      </span>
                      <span className="font-sans text-[14px] md:text-[15px] text-ink leading-snug" data-id="element-460">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Bonus Card — WhatsApp support */}
              <div className="w-full bg-gold-soft border border-gold rounded-2xl p-4 text-left mb-8" data-id="element-461">
                <div className="flex items-start gap-3" data-id="element-462">
                  <span className="text-2xl flex-shrink-0 leading-none" data-id="element-463">
                    🎁
                  </span>
                  <p className="text-[14px] md:text-[15px] text-ink leading-snug" data-id="element-464">
                    <strong className="font-bold text-rose-deep" data-id="element-465">Bônus:</strong>{' '}
                    você terá uma equipe de atendimento no WhatsApp todos os
                    dias da semana para tirar dúvidas!
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <a href={checkoutHref} target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout');
              }
            }} className="w-full flex items-center justify-center gap-2 bg-rose text-white py-4 md:py-5 rounded-full font-bold text-lg md:text-xl hover:bg-rose-deep transition-all hover:scale-[1.02] shadow-lg no-underline mb-4" data-id="element-466">
                Quero minha Aurora
                <ArrowRight size={20} data-id="element-467" />
              </a>

              {/* Microcopy */}
              <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-[12px] md:text-[13px] text-ink/70 font-medium" data-id="element-468">
                <span className="flex items-center gap-1" data-id="element-469">
                  🔒 Pagamento 100% seguro pelo Hotmart
                </span>
                <span className="hidden md:inline" data-id="element-470">·</span>
                <span className="flex items-center gap-1" data-id="element-471">
                  💳 Cartão ou Pix
                </span>
                <span className="hidden md:inline" data-id="element-472">·</span>
                <span className="flex items-center gap-1" data-id="element-473">
                  ⚡ Acesso na hora
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}